module.exports = __webpack_public_path__ + "static/media/Kudos Audio C20 Speakers.0a3ca058.jpg";